module.exports = __webpack_public_path__ + "static/media/Cancel-icon.19525ce8.svg";